export const classInfo = {
    "One year old": {
        label: { en: "1 yr", it: "1 anno" },
        tooltip: {
            en: "One year old — current season's growth. Smooth, green-brown bark. Preserve for grape production — grapes grow on one-season-old buds.",
            it: "Un anno — crescita della stagione corrente. Corteccia liscia, verde-marrone. Da preservare per la produzione — l'uva cresce sulle gemme di un anno.",
        },
    },
    "Two year old": {
        label: { en: "2 yr", it: "2 anni" },
        tooltip: {
            en: "Two year old — last season's wood. Rougher texture, darker bark. Cut to spur position to produce two new shoots next season.",
            it: "Due anni — legno della stagione scorsa. Texture più ruvida, corteccia più scura. Tagliare allo sperone per produrre due nuovi germogli la prossima stagione.",
        },
    },
    "Three year old": {
        label: { en: "3+ yr", it: "3+ anni" },
        tooltip: {
            en: "Three+ year old — older structural wood. Deep bark texture (ritidoma). Usually removed unless it serves as a cordon arm.",
            it: "Tre+ anni — legno strutturale più vecchio. Texture profonda della corteccia (ritidoma). Di solito rimosso, a meno che non serva come braccio del cordone.",
        },
    },
    Support: {
        label: { en: "Support", it: "Supporto" },
        tooltip: {
            en: "Support structure — wires, poles, ties. The model learns to ignore these so it never confuses metal/plastic with vine wood.",
            it: "Struttura di supporto — fili, pali, legature. Il modello impara a ignorarli per non confondere metallo/plastica con il legno della vite.",
        },
    },
};
/** Fallback for classes not in our map. */
export const unknownClassInfo = {
    label: { en: "Unknown", it: "Sconosciuto" },
    tooltip: {
        en: "Unrecognized class — the model detected something not in the expected categories.",
        it: "Classe non riconosciuta — il modello ha rilevato qualcosa non nelle categorie previste.",
    },
};
